import styled from '@emotion/styled'

import { Button1 } from './Button1'

export const Button2 = styled(Button1)({
  fontSize: '1rem', // 16px
})
